import { appendQueryParams } from 'content-creation-common/utils/url';

import queryString from 'querystring';

export { appendQueryParams };

export function getQueryStringParams() {
  return queryString.parse(location.search && location.search.substr(1));
}

export function getParamValue(paramName, defaultValue = null) {
  const queryStringParams = getQueryStringParams();
  return queryStringParams[paramName] || defaultValue;
}
